// extracted by mini-css-extract-plugin
module.exports = {"title":"timeout_title_1ZoOB"};